import React from "react"
import { Button } from "./Button"
import { LoadingButtonBody } from "./LoadingButtonBody"
export function OutlinedButton({ label, disabled, onClick, className, loading = false }: { label: string, disabled?: boolean, className?: string, onClick: () => void, loading?: boolean }): JSX.Element {
  return <Button onClick={onClick} className={`h-10 px-8 w-fit bg-transparent border-2 font-medium rounded-xl transition-all duration-300 ease-out flex items-center justify-center`
    .concat(className ? ` ${className}` : "")} disabled={disabled || loading} loading={loading}>
    <LoadingButtonBody label={label} loading={loading} />
  </Button>
}